/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import type {
  AppPreviewGallerySlots,
  AppPreviewGalleryState,
} from "./AppPreviewGallery.types";
import { assertSlots } from "@fluentui/react-components";

export const renderAppPreviewGallery = (state: AppPreviewGalleryState) => {
  assertSlots<AppPreviewGallerySlots>(state);

  return (
    <state.root>
      <state.hiddenFlyoutAnchor />
      <state.container>
        <state.buttonDisplay />
        <div>
          <state.actionFlyoutAnchor />
        </div>
      </state.container>
    </state.root>
  );
};
